import { render, staticRenderFns } from "./clientMarker.vue?vue&type=template&id=b5d3da2c&scoped=true&"
import script from "./clientMarker.vue?vue&type=script&lang=js&"
export * from "./clientMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d3da2c",
  null
  
)

export default component.exports